import type { ReactNode } from "react";
import { ArrowRightGlyph } from "./profile-glyphs";

interface ProfileInfoListItem {
  accentClassName: string;
  icon: ReactNode;
  title: string;
  type: string;
}

interface ProfileInfoListProps {
  items: ProfileInfoListItem[];
  onSelect: (type: string) => void;
}

export const ProfileInfoList = ({ items, onSelect }: ProfileInfoListProps) => {
  return (
    <section className="mt-5 overflow-hidden rounded-[22px] border border-[#EEF0ED] bg-white p-2 shadow-[0_12px_28px_rgba(22,24,28,0.035)]">
      {items.map((item, index) => (
        <button
          key={item.type}
          type="button"
          onClick={() => onSelect(item.type)}
          className="relative flex h-[82px] w-full items-center gap-4 rounded-[17px] px-3 text-left transition-colors active:bg-[#F7F8F3]"
        >
          <span
            className={`flex size-[54px] shrink-0 items-center justify-center rounded-[17px] ${item.accentClassName}`}
          >
            {item.icon}
          </span>
          <span className="min-w-0 flex-1 text-[19px] font-semibold leading-[1.08] text-[#565A5E]">
            {item.title}
          </span>
          <ArrowRightGlyph className="size-[25px] shrink-0 text-[#44494E]" />
          {index < items.length - 1 && (
            <span
              aria-hidden="true"
              className="absolute bottom-0 left-[82px] right-3 h-px bg-[#EFF0EE]"
            />
          )}
        </button>
      ))}
    </section>
  );
};
